import { render } from "./AuthLayout.vue?vue&type=template&id=ba216dec"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=ba216dec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__